<div data-testid="stock-search-page" class="p-6 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "inventory_lookup.title" | translate }}
  </h2>

  <!-- Search Form -->
  <app-search-form
    data-testid="stock-search-search-form"
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'stock-search-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      @if (canCreate()) {
        <app-button
          [testId]="'stock-search-create-purchase-requisition-btn'"
          [label]="
            'inventory_lookup.actions.create_purchase_requisition' | translate
          "
          type="info"
          icon="add"
          [disabled]="!hasSelectedItems()"
          [pTooltip]="
            !hasSelectedItems()
              ? ('inventory_lookup.messages.select_items' | translate)
              : ''
          "
          tooltipPosition="top"
          [showDelay]="300"
          (emitOnClick)="onCreatePurchaseRequisition()"
        ></app-button>
      }
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="table-section flex-table-section">
    <advanced-data-table
      data-testid="stock-search-table"
      #advancedTable
      [dataSource]="filteredStockItems()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [referenceColumnOrder]="referenceColumnOrder()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="canCreate()"
      [selection]="selectedItems()"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      class="w-full"
      (pageChange)="onPageChange($event)"
      (selectionChange)="onSelectionChange($event)"
    >
      <!-- Custom Actions Template -->
      <ng-template #actionsTemplate let-record>
        <div class="flex gap-2 justify-center">
          @if (canRead()) {
            <span
              [attr.data-testid]="'stock-search-action-view-' + record.id"
              (click)="onViewDetails(record)"
              class="action-link action-edit cursor-pointer"
            >
              {{ "common.actions.view" | translate }}
            </span>
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>
</div>
